import { TokenState } from "./token";

export const getSafeTokenPrice = (tokenState: TokenState, tokenSymbol: string): number => {
    if (!tokenSymbol) return 0;
    return tokenState.tokenPriceMap[tokenSymbol] ?? tokenState.tokenPriceMap[tokenSymbol.toUpperCase()];
}
